import { render, staticRenderFns } from "./coachBond.vue?vue&type=template&id=28fd063c&"
import script from "./coachBond.vue?vue&type=script&lang=js&"
export * from "./coachBond.vue?vue&type=script&lang=js&"
import style0 from "./coachBond.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports